import { showToast } from "../../utils/ToastHelper";
export const logout_func2 = (setOnlogoutHide,history) => {
  localStorage.removeItem("is_logged_in");
  localStorage.removeItem("access_token");
  localStorage.removeItem("userData");

  // Some screens pass non-function placeholders (e.g. 0) instead of a state setter.
  // Guarding this keeps token-expiry logout from crashing the app.
  if (typeof setOnlogoutHide === "function") {
    setOnlogoutHide(1);
  }

  showToast("success", "Invalid Token");

  if (history && typeof history.push === "function") {
    history.push("/login");
    return;
  }

  window.location.assign("/login");
};
export const logout_func3 = (history) => {
  localStorage.removeItem("is_logged_in");
  localStorage.removeItem("access_token");
  localStorage.removeItem("userData");
//   showToast("success", "Invalid Token");
  history.push("/login");
};